import { BaseService, type PagedResponse } from '@/services/common/base.service'
import type { MembershipDto, MembershipQuery, ExtendMembershipInput } from './models'

/**
 * 会员服务
 */
export class MembershipService extends BaseService {
  protected readonly baseUrl = '/api/app/membership'

  /**
   * 获取当前用户会员信息
   */
  async getMyMembership(): Promise<MembershipDto | null> {
    return await this.get<MembershipDto | null>('')
  }

  /**
   * 检查当前用户是否为有效会员
   */
  async checkStatus(): Promise<boolean> {
    return await this.get<boolean>('/check-status')
  }

  /**
   * 获取当前用户会员过期日期
   */
  async getExpireDate(): Promise<string | null> {
    return await this.get<string | null>('/expire-date')
  }

  /**
   * 获取会员列表（管理员）
   */
  async getList(query: MembershipQuery = {}): Promise<PagedResponse<MembershipDto>> {
    return await this.get<PagedResponse<MembershipDto>>('', query)
  }

  /**
   * 根据用户ID获取会员信息（管理员）
   */
  async getByUserId(userId: string): Promise<MembershipDto> {
    return await this.get<MembershipDto>(`/by-user/${userId}`)
  }

  /**
   * 延长会员有效期（管理员）
   */
  async extend(id: string, input: ExtendMembershipInput): Promise<void> {
    await this.put<void>(`/${id}/extend`, input)
  }
}

// 导出单例
export const membershipService = new MembershipService()
